import React from 'react';
import './styles/payments.scss';

function ProductPaymentDetail(props) {
  const { payment = {} } = props;

  if (payment.programInfo) {
    return (
      <div>
        <div><strong>Donación a programa</strong></div>
        <br />
        <div>Programa: {payment.programInfo.name}</div>
        <div>Organización: {payment.programInfo.foundationName}</div>
      </div>
    );
  }
  if (payment.productInfo) {
    return (
      <div>
        <div><strong>Compra de producto</strong></div>
        <br />
        <div>Producto: {payment.productInfo.name}</div>
        <div>Comercio: {payment.productInfo.enterpriseName || payment.productInfo.foundationName}</div>
      </div>
    );
  }
  if (payment.foundationInfo) {
    return (
      <div>
        <div><strong>Donación a organización</strong></div>
        <br />
        <div>Organización: {payment.foundationInfo.name}</div>
      </div>
    );
  }

  return (<div><strong>Recarga al Wallet Nibi</strong></div>);
}

export default ProductPaymentDetail;
